import types from '@/actions/types';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';
import useConfig from '@/composables/useConfig';

export default class Pause extends Base {
  constructor(params) {
    super(params, types.PAUSE);

    this.timeout = null;
  }

  execute() {
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      this.restart();
    });
  }

  stopTimeout() {
    clearTimeout(this.timeout);
  }

  restart() {
    let duration = this.params.value;

    if (this.params.useVariable && this.params.variableId) {
      const { getVariable } = useConfig();
      const variable = getVariable(this.params.variableId);
      const value = parseInt(variable.value, 10);
      if (!Number.isNaN(value)) {
        duration = value * 1000;
      }
    }

    if (duration === -1000) {
      return;
    }
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this.resolve, duration);
  }

  stop() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.resolve();
  }

  pause() {
    this.stopTimeout();
  }

  resume() {
    this.restart();
  }
}
